import { UpdateRecordCollectionAction } from '../../redux/collection-reducer';
import { KeyTaxDirective } from '../reducer';
import { UPDATE_KEY_TAX_DIRECTIVE } from '../views/key-tax-directive/types';
export type UpdateKeyTaxDirectiveAction = UpdateRecordCollectionAction<KeyTaxDirective>;

export const updateKeyTaxDirectiveActionCreator = (
    keyTaxDirectiveIndex: number,
    keyTaxDirective: KeyTaxDirective
): UpdateKeyTaxDirectiveAction => {
    return {
        type: UPDATE_KEY_TAX_DIRECTIVE,
        record: keyTaxDirective,
        index: keyTaxDirectiveIndex,
    };
};
